export const noPermission =
{
    
    path: "/noPermission",
    component: () => import("@/views/noPermission/index"),
    meta: {
        hidden: false,
    },
}
export const excessive =
{
    path: "/excessive",
    component: () => import("@/views/noPermission/excessive"),
    meta: {
        hidden: false,
    },
}
export const noPermissionH5 =
{
    path: "/noPermissionH5",
    component: () => import("@/views/noPermission/indexH5"),
    meta: {
        hidden: false,
    },
}
export const excessiveH5 =
{
    path: "/excessiveH5",
    component: () => import("@/views/noPermission/excessiveH5"),
    meta: {
        hidden: false,
    },
}